import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { ledger } = stateEnum

const initialState = {   
  account: {
    acId: "",
    acDesc: "", 
    compCode:""
  }, 
  filter:{
    actypeid:"",
    actypename:"",
    todate:"",
    fromdate:""
  }
}
 
 
 

const ledgerSlice = createSlice({
  name: ledger,
  initialState,
  reducers: {  
    /*new */
    setFilter: (state, action) => {
      state.filter={
        actypeid:action.payload.actypeid,
        actypename:action.payload.actypename,
        todate:action.payload.todate,
        fromdate:action.payload.fromdate,
        //acid:action.payload.acid
      }
    },
    resetFilter: (state) => {
      state.filter={
        actypeid:"",
        actypename:"",
        todate:"",
        fromdate:""
      }
    },
    setAccount: (state, action) => {
      state.account = {
        acId: action.payload.acId,
        acDesc: action.payload.acDesc, 
        compCode:action.payload.compCode
      }
    },
    resetAccount: (state) => {
      
      state.account = {
        acId: "",
        acDesc: "",
        compCode:""
      }
    },
  }, 
})

export const { setFilter, resetFilter, setAccount, resetAccount,  } =
  ledgerSlice.actions
export default ledgerSlice.reducer
